// extracted by mini-css-extract-plugin
module.exports = {"authorLink":"_3DXap","didYouMeanLink":"_2tqY8","authorText":"_1B7oV","didYouMeanText":"_V6qk","seoHeading":"_2AqEv","seoSubHeading":"_3hUzI"};